<div
    (click)="onboard()"
    class="d-flex m-1 p-2 background-light-gray rounded-2 gap-4 ps-4"
    [ngClass]="{'pointer pointer-hover-blue': userStore.canEdit()}">
    <img src="icons/tag.svg" class="icon"/>
    <div class="d-flex flex-column justify-content-center">
        <span class="fw-bold">{{ id() | slice:-5}}</span>
        <div class="d-flex flex-row gap-2">
            @if (showGpsData()) {
                <div class="{{ lastSeenBySatelliteMessageColorClass() }} text-nowrap color-secondary-information">
                    <i class="fa-solid fa-location-dot {{ lastSeenBySatelliteMessageColorClass() }}"></i>
                    {{ lastSeenBySatelliteMessage() }}
                </div>
                |
                <div class="{{ lastSeenByLoRaGatewayColorClass() }} text-nowrap color-secondary-information">
                    <i class="fa-solid fa-tower-cell {{ lastSeenByLoRaGatewayColorClass() }}"></i>
                    {{ lastSeenByLoRaGatewayMessage() }}
                </div>
            }
            @if (showGpsData() && showBleData()) {
                |
            }
            @if (showBleData()) {
                <div class="text-nowrap {{ lastSeenByBLEScannerMessageColorClass() }} color-secondary-information">
                    <i class="fa-brands fa-bluetooth-b {{ lastSeenByBLEScannerMessageColorClass() }}"></i>
                    {{ lastSeenByBLEScannerMessage() }}
                </div>
                |
                <div class="text-nowrap color-secondary-information">
                    {{ rssi() }}
                </div>
            }
        </div>
    </div>
</div>
